export default async function fetchIndustryBrandCarouselData(parameter: string) {
    try {
        const endpointurl = `/api/v2/GetIndustryBrandsData?name=${parameter}`;
        const response = await fetch(endpointurl);
        return response;
    } catch (error) {
        throw error;
    }
}
